// extracted by mini-css-extract-plugin
export var subtitle = "_9d-2";
export var title = "_9d-0";
export var titleNoWrap = "_9d-1";